import React from "react";
import clap_graphic from "../../assets/images/clap-graphic.png";
import clap_service_logo from "../../assets/images/clap-service-logo.png";
import { ClapVersion } from "../../shared/constant";

interface Props {
  children: JSX.Element;
}

function BgWrapper({ children }: Props) {
  return (
    <>
      <div className="default-text h-screen bg-clap grid place-content-center">
        <div className="invisible md:visible absolute bottom-0 left-0">
          <img
            src={clap_graphic}
            width={624}
            height={229}
            alt="CLAP Graphics"
          />
        </div>
        <div className="flex justify-center pb-7">
          <img
            src={clap_service_logo}
            alt="CLAP Service Logo"
            width={153}
            height={153}
          />
        </div>
        {children}
      </div>
      <div
        className="absolute left-5 bottom-5 text-river-bed"
        style={{ lineHeight: "1.5715" }}
      >
        {ClapVersion}
      </div>
    </>
  );
}

export default BgWrapper;
